"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _noop = _interopRequireDefault(require("lodash/noop"));

var logger = function logger(_ref) {
  var isOn = _ref.isOn;
  var handler = {
    get: function get(obj, prop) {
      return prop in obj && isOn ? obj[prop] : _noop["default"];
    }
  };
  return new Proxy(console || {}, handler);
};

var _default = logger;
exports["default"] = _default;